export default __webpack_public_path__ + "static/logobezherbu-150ca4ab87fb5c42b2af10538b5847ac.svg";